import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import { AssignVendorToSubcategoryCommand } from './vendor-rate.commands';
import { AssignedVendorToSubcategoryEvent } from './vendor-rate.events';

@Injectable()
export class VendorRateEffects {
  assignVendorToSubcategoryCommand: Observable<Action<string>> & CreateEffectMetadata;

  prefix = 'vendor-rate';
  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.assignVendorToSubcategoryCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      AssignVendorToSubcategoryCommand,
      AssignedVendorToSubcategoryEvent,
      this.prefix,
    );
  }
}
